
const getScrollbarWidth = () =>
  {
    /**
     * calculate scrollbar width minus scrollbar width to prevent overflow from 100vw
     */

    let didCompute = false;
    let widthRef = 0;
    let scrollbarWidth;

    if (didCompute) {
      scrollbarWidth = widthRef;
    } else {
      // Creating invisible container
      const outer = document.createElement('div');
      outer.style.visibility = 'hidden';
      outer.style.overflow = 'scroll'; // forcing scrollbar to appear
      // @ts-ignore
      outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
      document.body.appendChild(outer);
      // Creating inner element and placing it in the container
      const inner = document.createElement('div');
      outer.appendChild(inner);
      // Calculating difference between container's full width and the child width
      scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
      // Removing temporary elements from the DOM
      outer.parentNode.removeChild(outer);
      didCompute = true;
      widthRef = scrollbarWidth;
    }

    return scrollbarWidth
  }

export {getScrollbarWidth};